const textProps = {
  video: "https://d1djs83rh1f7lb.cloudfront.net/light.mp4",
  title: "Revolutionizing Software Development with Innovation and Expertise.",
  description:
    "At the forefront of technology, we provide cutting-edge solutions tailored to your needs. Our team of experts delivers efficient and innovative software design and development services, ensuring your success in a fast-paced digital world.",
  skew: {
    color: "white",
  },
  typeStrings: ["Empowering Efficiency", "Fueling Innovation", "Delivering Expertise"],
};
export default textProps;
